import { httpsCallable } from 'firebase/functions';
import { firebase } from './firebase';

export const ADMIN_EMAIL = 'mike@marcucio.com';

export function isAdmin(email: string | null | undefined): boolean {
  return !!email && email.toLowerCase() === ADMIN_EMAIL;
}

export interface AdminUser {
  uid: string;
  email: string | null;
  createdAt: string | null;
  lastSignInAt: string | null;
  disabled: boolean;
  snippetsTotal: number;
  storageBytes: number;
  snippetsToday: number;
  snippetsTodayDate: string | null;
}

export interface AdminSnippet {
  id: string;
  title: string;
  storagePath: string;
  sizeBytes: number;
  createdAtMs: number | null;
}

export interface AdminSnippetsPage {
  snippets: AdminSnippet[];
  limit: number;
  hasMore: boolean;
}

export async function adminListUsers(): Promise<AdminUser[]> {
  const call = httpsCallable<unknown, { users: AdminUser[] }>(
    firebase.functions,
    'adminListUsers',
  );
  const res = await call({});
  return res.data.users;
}

export async function adminListUserSnippets(uid: string): Promise<AdminSnippetsPage> {
  const call = httpsCallable<{ uid: string }, AdminSnippetsPage>(
    firebase.functions,
    'adminListUserSnippets',
  );
  const res = await call({ uid });
  return res.data;
}
